import { Suspense, lazy } from "react";
import "./App.scss";
import { ToastContainer } from "react-toastify";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import {
  HOME_ROUTE,
  LOGIN_ROUTE,
  DASHBOARD_ROUTE,
  DASHBOARD_USERS_ROUTE,
  DASHBOARD_TRANSACTIONS_ROUTE,
  DRAW_ROUTE,
  ROULETTE_ROUTE,
  DASHBOARD_ROLES_ROUTE,
  DASHBOARD_PERMISSION_ROUTE,
  DASHBOARD_PRODUCTS_ROUTE,
  DRAW_WINNER_ROUTE,
  DRAW_TOKENS_ROUTE,
  DRAW_TEMP_TOKENS_ROUTE,
  DASHBOARD_MESSAGES_ROUTE,
  DASH_DRAW_ROUTE,
  DASHBOARD_PAYMENT_ROUTE,
  DASHBOARD_RADIO_ROUTE,
  DASHBOARD_BLACKLIST_ROUTE,
  DASHBOARD_REFFERS_ROUTE,
  DRAW_CALENDER_ROUTE,
  ROULETTE_ROUTE_ALL,
  DASHBOARD_PLAYERS_ROUTE,
  DASHBOARD_SMS_ROUTE,
  UNPROTECTED_REFERRER,
  SIGNUP_ROUTE,
  MY_REFERRER_ROUTE,
} from "./helpers/routes";
import Loader from "./components/etc/loader";
import ReferrerTransactions from "./components/etc/RefererTransactions";
import UnplayedDraws from "./pages/dashboard/draw/roulette/unplayed";
import Player from "./pages/dashboard/player";
import SMSListPage from "./pages/dashboard/sms";
import ReferrerUnprotected from "./pages/dashboard/referrer_unprotected";
import SignupPage from "./pages/auth/signup";
import MyReferrerTransactions from "./pages/dashboard/referrer_unprotected/referrer_transactions";
import TermsAndConditions from "./pages/home/terms&condition";

const AuthLayout = lazy(() => import("./components/layout/default/auth"));
const PageLayout = lazy(() => import("./components/layout/default"));
const DashboardLayout = lazy(() => import("./components/layout/dashboard"));

const HomePage = lazy(() => import("./pages/home"));
const Login = lazy(() => import("./pages/auth/login"));
// const SignupPage = lazy(() => import("./pages/auth/signup"));

const DashHomePage = lazy(() => import("./pages/dashboard/home"));
const DashUsersPage = lazy(() => import("./pages/dashboard/users"));
const DashTransactionsPage = lazy(() => import("./pages/dashboard/transactions"));
const DashPaymentPage = lazy(() => import("./pages/dashboard/payment"));
const DashRolesPage = lazy(() => import("./pages/dashboard/roles"));
const DashPermissionsPage = lazy(() => import("./pages/dashboard/permissions"));
const DashProductsPage = lazy(() => import("./pages/dashboard/products"));
const DashMessagesPage = lazy(() => import("./pages/dashboard/messages"));
const DashRadioPage = lazy(() => import("./pages/dashboard/radio"));
const DashBlackListPage = lazy(() => import("./pages/dashboard/blackList"));
const DashReffersPage = lazy(() => import("./pages/dashboard/refffers"));
const RoulettePage = lazy(() => import("./pages/dashboard/draw/roulette"));
const DashDrawList = lazy(() => import("./pages/dashboard/draw/list"));
const WinnersPage = lazy(() => import("./pages/dashboard/draw/winners"));
const DashTokensPage = lazy(() => import("./pages/dashboard/draw/tokens"));
const DashTempTokensPage = lazy(() => import("./pages/dashboard/draw/tempTokens"));
const DrawCalender = lazy(() => import("./pages/dashboard/draw/list/calender"));

function App() {
  return (
    <>
      <Suspense fallback={<Loader />}>
        <Routes>
        <Route path={UNPROTECTED_REFERRER} element={<ReferrerUnprotected />} />
          <Route
            path={"/"}
            element={
              <AuthLayout>
                <Outlet />
              </AuthLayout>
            }
          >
            <Route path={LOGIN_ROUTE} element={<Login />} />
            <Route path={`${SIGNUP_ROUTE}/:step/*`} element={<SignupPage />} />
            <Route path={`${SIGNUP_ROUTE}/*`} element={<SignupPage />} />
          </Route>

          {/* Default pages */}
          <Route
            path={HOME_ROUTE}
            element={
              <PageLayout>
                <Outlet />
              </PageLayout>
            }
          >
            <Route index element={<HomePage />} />
            <Route  path="/terms" element={<TermsAndConditions />} />
          </Route>

          {/* dashboard pages */}
          <Route
            path={`${DASHBOARD_ROUTE}`}
            element={
              <DashboardLayout>
                <Suspense fallback={<Loader />}>
                  <Outlet />
                </Suspense>
              </DashboardLayout>
            }
          >
            <Route index element={<DashHomePage />} />
            
            <Route path={DASHBOARD_USERS_ROUTE} element={<DashUsersPage />} />
            <Route path={DASHBOARD_BLACKLIST_ROUTE} element={<DashBlackListPage />} />
            <Route path={DASHBOARD_REFFERS_ROUTE} element={<DashReffersPage />} />
            <Route
        path={`${DASHBOARD_REFFERS_ROUTE}/:referrerId`} // Dynamic route parameter
        element={<ReferrerTransactions />}

      />
             <Route
        path={`${DASHBOARD_REFFERS_ROUTE}/:referrerId`} // Dynamic route parameter
        element={<ReferrerTransactions />}

      />
      
             <Route
        path={`${DASHBOARD_REFFERS_ROUTE}/:referrerId`} // Dynamic route parameter
        element={<ReferrerTransactions />}

      />
          <Route
        path={`${MY_REFERRER_ROUTE}`}
        element={<MyReferrerTransactions />}

      />

      
            <Route path={DASHBOARD_ROLES_ROUTE} element={<DashRolesPage />} />
            <Route path={DASHBOARD_PRODUCTS_ROUTE} element={<DashProductsPage />} />
            <Route path={DASHBOARD_PERMISSION_ROUTE} element={<DashPermissionsPage />} />
            <Route path={DASHBOARD_SMS_ROUTE} element={<SMSListPage />} />
            <Route path={DASHBOARD_TRANSACTIONS_ROUTE} element={<DashTransactionsPage />} />
            <Route path={DASHBOARD_PLAYERS_ROUTE} element={<Player />} />
            <Route path={DASHBOARD_PAYMENT_ROUTE} element={<DashPaymentPage />} />
            <Route path={DASHBOARD_MESSAGES_ROUTE} element={<DashMessagesPage />} />
            <Route path={DASHBOARD_RADIO_ROUTE} element={<DashRadioPage />} />

            <Route path={DASH_DRAW_ROUTE} element={<DashDrawList />} />
            <Route path={DRAW_WINNER_ROUTE} element={<WinnersPage />} />
            <Route path={DRAW_CALENDER_ROUTE} element={<DrawCalender />} />
            <Route path={DRAW_TOKENS_ROUTE} element={<DashTokensPage />} />
            <Route path={DRAW_TEMP_TOKENS_ROUTE} element={<DashTempTokensPage />} />

            {/* User Route Not found */}
            <Route path="*" element={<Navigate to={DASHBOARD_ROUTE} />} />
          </Route>

          <Route
            path={DRAW_ROUTE}
            element={
              <DashboardLayout mainOnly className="bg-primary2">
                <Suspense fallback={<Loader />}>
                  <Outlet />
                </Suspense>
              </DashboardLayout>
            }
          >
            
            <Route path={`${ROULETTE_ROUTE}`} element={<RoulettePage />} />
            <Route path={`${ROULETTE_ROUTE_ALL}`} element={<UnplayedDraws />} />
            <Route path={`${ROULETTE_ROUTE}/:id`} element={<RoulettePage />} />
          </Route>


        
          <Route path="*" element={<Navigate to={HOME_ROUTE} />} />
        </Routes>
      </Suspense>
      <ToastContainer />
    </>
  );
}

export default App;
